import { Route } from 'react-router-dom'
import { Page } from '~/components/Page'
import { PageBanner } from '~/components/PageBanner'
import { BackToTop } from '~/components/ui'
import banner from './assets/banner.png'
import { MarketplaceProvider } from './context'
import { Martketplace } from './components/Marketplace'

const MarketplacePage = () => {
    return (
        <Page title='Marketplace' header='Marketplace'>
            <PageBanner imageURL={banner} text='MARKETPLACE' />
            {/* 16px gutter on a phone rather than 8px; the heading and subtitle were sitting almost
                against the screen edges. */}
            <section className='px-4 sm:px-2'>
                <div className='font-bold container-inline'>
                    <h2 className='text-[max(var(--text-lg),2.35cqi)]'>EXPLORE COLLECTIONS</h2>
                    <h3 className='text-[max(var(--text-2xs),1.3cqi)] mb-[2em] uppercase'>
                        Buy, play, trade or sell your BR1 assets with other players.
                    </h3>
                </div>
                <MarketplaceProvider>
                    <Martketplace />
                </MarketplaceProvider>
            </section>
            <BackToTop />
        </Page>
    )
}

export const MarketplaceRoutes = [<Route key='marketplace-index' index element={<MarketplacePage />} />]
